import React from 'react';
import { Hero } from '../components/Hero';
import { Story } from '../components/Story';
import { Method } from '../components/Method';
import { Gallery } from '../components/Gallery';
import { Offer } from '../components/Offer';
import { Bonus } from '../components/Bonus';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-brand-ivory selection:bg-brand-gold selection:text-white" data-id="element-275">
      <Hero data-id="element-276" />
      <Story data-id="element-277" />
      <Method data-id="element-278" />
      <Gallery data-id="element-279" />
      <Offer data-id="element-280" />
      <Bonus data-id="element-281" />
      <Footer data-id="element-282" />
    </div>;
}